function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M875 5096 c-58 -27 -88 -57 -110 -108 -13 -33 -15 -233 -15 -1818 0 -1585 2 -1785 15 -1818 22 -51 52 -81 110 -108 l50 -24 712 0 712 0 3 -539 3 -539 30 -44 c37 -53 120 -98 179 -98 48 0 131 37 163 71 53 58 53 58 53 623 l0 525 729 3 729 3 43 30 c23 17 53 50 66 74 l23 44 0 1294 c0 1145 -2 1298 -15 1331 -24 56 -1033 1064 -1099 1097 l-50 25 -1140 0 -1141 0 -50 -24z m2085 -888 c0 -438 2 -476 19 -514 26 -57 92 -110 153 -123 30 -7 202 -11 438 -11 l390 0 0 -960 0 -960 -587 2 -588 3 -3 428 c-1 235 1 427 6 427 4 0 54 -43 111 -95 113 -103 146 -120 226 -113 111 9 182 81 192 195 8 98 -6 115 -332 416 -159 147 -308 276 -331 287 -56 28 -139 27 -192 -2 -65 -36 -610 -544 -634 -592 -39 -76 -24 -179 36 -244 53 -59 161 -81 239 -49 19 9 83 59 141 112 l106 97 0 -436 0 -436 -582 2 -583 3 -3 1518 -2 1517 890 0 890 0 0 -472z m835 -220 c5 -4 -84 -8 -198 -8 l-207 0 0 202 0 201 198 -193 c108 -107 201 -198 207 -202z"
}));
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.e5e56d122cdbb4d5d75969b6e340807e.svg";
export { ForwardRef as ReactComponent };